import { ICONS, COLORS } from "@/components/appbuilder/missions";

export default function AppLogo({ logo, size = 56 }) {
  const Icon = ICONS[logo?.icon] || ICONS.Lightbulb;
  const color = COLORS[logo?.color] || COLORS.yellow;
  return (
    <div
      className={`${color.bg} ${logo?.shape === "round" ? "rounded-full" : "rounded-[28%]"} border-4 border-white shadow-lg flex items-center justify-center shrink-0`}
      style={{ width: size, height: size }}
      data-testid="app-logo"
    >
      <Icon className="text-white drop-shadow" style={{ width: size * 0.55, height: size * 0.55 }} strokeWidth={2.4} />
    </div>
  );
}
